import { useScrollReveal } from '@/hooks/useScrollReveal';
import { testimonials } from '@/mocks/landingData';

export default function Testimonials() {
  useScrollReveal('.testimonials-reveal', 0.1);

  return (
    <section id="testimonials" className="py-10 md:py-16 bg-cream">
      <div className="section-padding">
        <div className="max-w-3xl mx-auto text-center mb-8 md:mb-12">
          <div className="testimonials-reveal scroll-reveal">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary/5 border border-primary/10 rounded-full font-body text-[10px] md:text-xs tracking-[0.2em] uppercase text-primary">
              <span className="w-1.5 h-1.5 bg-gold rounded-full" />
              Investor Stories
            </span>
          </div>
          <h2 className="testimonials-reveal scroll-reveal font-display text-2xl md:text-4xl lg:text-5xl text-charcoal font-bold mt-4 md:mt-5 leading-tight">
            Trusted by <span className="text-gradient-gold">Smart Investors</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto">
          {testimonials.map((t, index) => (
            <div
              key={t.name}
              className="testimonials-reveal scroll-reveal bg-white rounded-2xl p-5 md:p-7 border border-cream-dark/50 hover:border-gold/30 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-xl group"
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="flex items-center gap-1 mb-3 md:mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-gold text-xs md:text-sm" />
                ))}
              </div>
              <p className="font-body text-sm text-charcoal/70 leading-relaxed mb-5 md:mb-6 italic">
                &ldquo;{t.review}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-cream-dark/50">
                <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-gold/10 transition-colors duration-500">
                  <span className="font-display text-xs md:text-sm font-bold text-primary group-hover:text-gold transition-colors duration-500">
                    {t.name.split(' ').map(n => n[0]).join('')}
                  </span>
                </div>
                <div>
                  <h4 className="font-body text-xs md:text-sm font-semibold text-charcoal">{t.name}</h4>
                  <p className="font-body text-[10px] md:text-xs text-charcoal/50">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}